import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  class: "btn-group w-100",
  role: "group",
  "aria-label": "Risk option"
}
const _hoisted_3 = {
  key: 0,
  class: "col-sm-3 mt-3 mt-sm-0 d-flex align-items-end"
}
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = {
  ref: "returnRate",
  type: "text",
  class: "form-control text-center mt-0",
  placeholder: "",
  "aria-label": "Estimated annual growth percentage",
  value: "3.5%",
  disabled: ""
}
const _hoisted_7 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_button = _resolveComponent("radio-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.optionsClass)
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.riskLevelDetails, (item, i) => {
          return (_openBlock(), _createBlock(_component_radio_button, {
            ref_for: true,
            ref: 'riskOption' + _ctx.mode,
            key: i,
            name: _ctx.getRadioButtonGroupName(),
            label: _ctx.getRiskLevelLabel(item),
            value: _ctx.riskLevel,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeRiskOption($event)))
          }, null, 8, ["name", "label", "value"]))
        }), 128))
      ])
    ], 2),
    (_ctx.canFineTune)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              ref: "decreaseRate",
              class: "btn btn-outline-secondary",
              type: "button",
              name: "decreaseRate",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDecreaseRateClick && _ctx.onDecreaseRateClick(...args))),
              "aria-label": _ctx.decreaseButtonAria
            }, " - ", 8, _hoisted_5),
            _createElementVNode("input", _hoisted_6, null, 512),
            _createElementVNode("button", {
              ref: "increaseRate",
              class: "btn btn-outline-secondary",
              type: "button",
              name: "increaseRate",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onIncreaseRateClick && _ctx.onIncreaseRateClick(...args))),
              "aria-label": _ctx.increaseButtonAria
            }, " + ", 8, _hoisted_7)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}